import { render, staticRenderFns } from "./OrderBody.vue?vue&type=template&id=1ac2feb5&scoped=true&"
import script from "./OrderBody.vue?vue&type=script&lang=js&"
export * from "./OrderBody.vue?vue&type=script&lang=js&"
import style0 from "./OrderBody.vue?vue&type=style&index=0&id=1ac2feb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac2feb5",
  null
  
)

export default component.exports